import { useState } from "react"
import { buildUrl } from "@planningcenter/cc-url"
import { Icon } from "source/shared/components"

export default function ImageCarousel() {
  interface ImageCarouselStep {
    stepDescription: string
    imageSrc: string
    imageAlt: string
  }

  const steps: ImageCarouselStep[] = [
    {
      stepDescription:
        'Send "GIVE $25" for a $25 donation to Carlsbad Church\'s General fund.',
      imageSrc: buildUrl("/images/text2give-step1.png"),
      imageAlt:
        "Mobile phone receiving text message response to 'GIVE $25' with instructions to proceed with donation",
    },
    {
      stepDescription: 'Click "Give now" on the confirmation screen.',
      imageSrc: buildUrl("/images/text2give-step2.png"),
      imageAlt:
        "Mobile phone displaying a request to complete the $25 Text2Give donation in Church Center",
    },
    {
      stepDescription: "Receive a success message after submitting.",
      imageSrc: buildUrl("/images/text2give-step3.png"),
      imageAlt:
        "Mobile phone displaying a 'Thank you!' confirmation of the $25 Text2Give donation in Church Center",
    },
    {
      stepDescription:
        "Receive a text confirmation when the donation is completed.",
      imageSrc: buildUrl("/images/text2give-step4.png"),
      imageAlt:
        "Mobile phone receiving text message response with the completed $25 donation details",
    },
  ]

  const [currentIndex, setCurrentIndex] = useState(0)

  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0
    const newIndex = isFirstSlide ? steps.length - 1 : currentIndex - 1
    setCurrentIndex(newIndex)
  }

  const goToNext = () => {
    const isLastSlide = currentIndex === steps.length - 1
    const newIndex = isLastSlide ? 0 : currentIndex + 1
    setCurrentIndex(newIndex)
  }
  return (
    <>
      <div className="d-f g-1 ai-fs">
        <div className="fs-3 fw-600">
          {currentIndex + 1}/{steps.length}
        </div>
        <div>{steps[currentIndex].stepDescription}</div>
      </div>
      <div className="d-f g-1 ai-c jc-c">
        <button
          className="btn minor-btn text-btn"
          onClick={goToPrevious}
          disabled={currentIndex === 0}
          aria-label="Previous"
        >
          <Icon symbol={`general#left-chevron`} aria-hidden="true" />
        </button>
        <img
          src={steps[currentIndex].imageSrc}
          alt={steps[currentIndex].imageAlt}
          style={{ maxWidth: "350px" }}
        />{" "}
        <button
          className="btn minor-btn text-btn"
          onClick={goToNext}
          disabled={currentIndex === steps.length - 1}
          aria-label="Next"
        >
          <Icon
            symbol={`general#right-chevron`}
            aria-hidden="true"
            fill="tint1"
          />
        </button>
      </div>
    </>
  )
}
